export const GATEWAY_FETCH_UNREACHABLE_MESSAGE =
  'Could not reach the gateway. The configured host or port may be invalid or unreachable.'
